"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActionBarOverlay = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Popover = _interopRequireDefault(require("react-bootstrap/Popover"));

var _excluded = ["children", "show", "preRender", "id", "title", "onClick", "width", "style", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ActionBarOverlay = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var children = props.children,
      show = props.show,
      preRender = props.preRender,
      id = props.id,
      title = props.title,
      onClick = props.onClick,
      width = props.width,
      style = props.style,
      className = props.className,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  var adjustedStyles = _objectSpread(_objectSpread({}, style), {}, {
    width: width
  });

  var adjustedClassName = preRender && !show ? (0, _classnames.default)(className, 'position-offscreen') : className;
  return /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
    ref: ref,
    id: id,
    onClick: onClick
  }, rest, {
    style: adjustedStyles,
    className: adjustedClassName
  }), title && /*#__PURE__*/_react.default.createElement(_Popover.default.Title, {
    className: "popover-title text-color-dark"
  }, title), /*#__PURE__*/_react.default.createElement(_Popover.default.Content, {
    className: "popover-content"
  }, children));
});

exports.ActionBarOverlay = ActionBarOverlay;
ActionBarOverlay.defaultProps = {
  placement: 'bottom',
  width: 250
};
ActionBarOverlay.propTypes = {
  id: _propTypes.default.string.isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string]),
  preRender: _propTypes.default.bool,
  show: _propTypes.default.bool,
  width: _propTypes.default.oneOf([100, 150, 200, 250, 300, 350, 400, 450, 500])
};
var _default = ActionBarOverlay;
exports.default = _default;